//
// Copyright 2026 DXOS.org
//

import * as Context from 'effect/Context';
import * as Rpc from 'effect/rpc/Rpc';
import type * as RpcClient from 'effect/rpc/RpcClient';
import * as RpcGroup from 'effect/rpc/RpcGroup';

import { ContactBookSchema } from './buf/proto/gen/dxos/client/services_pb.ts';
import { bufMessage, serviceError } from './service-rpc.ts';

/**
 * Effect RPC definitions for the client contacts service (formerly `dxos.client.services.ContactsService`).
 * Both methods take no payload; the response reuses the shared `ContactBook` proto type.
 */
export class Rpcs extends RpcGroup.make(
  Rpc.make('getContacts', {
    success: bufMessage(ContactBookSchema),
    error: serviceError,
  }),
  Rpc.make('queryContacts', {
    success: bufMessage(ContactBookSchema),
    error: serviceError,
    stream: true,
  }),
).prefix('ContactsService.') {}

export interface Client extends RpcClient.RpcClient<RpcGroup.Rpcs<typeof Rpcs>> {}

export interface Handlers extends RpcGroup.HandlersFrom<RpcGroup.Rpcs<typeof Rpcs>> {}

/**
 * Effect service tag for the `ContactsService` RPC handlers.
 */
export class Tag extends Context.Service<Tag, Handlers>()('@dxos/protocols/rpc/ContactsService') {}
